var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDirectionArrow = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 283.431,
    height: 243.386,
    viewBox: "0 0 283.431 243.386",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1645",
    "data-name": "Group 1645",
    transform: "translate(-502.77 -515.614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_14",
    "data-name": "Union 14",
    d: "M-4838-2088a6,6,0,0,1-6-6v-22a6,6,0,0,1,6-6h271.4a6,6,0,0,1,6,6v22a6,6,0,0,1-6,6Zm13.9-158a6,6,0,0,1-6-6v-11a6,6,0,0,1,6-6h242.5a6,6,0,0,1,6,6v11a6,6,0,0,1-6,6Z",
    transform: "translate(5346.801 2847)",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Union_13",
    "data-name": "Union 13",
    d: "M-4836-2049c-3.313,0-7.227-2.368-6-6,1.1-3.244,55.3-116.737,66.888-141h-48.1a5,5,0,0,1-2.274-9.454l122.209-62.385a5,5,0,0,1,4.547,0l122.208,62.385a5,5,0,0,1-2.273,9.454h-45.9c8.029,17.121,64.667,137.929,65.687,141,1.1,3.3-2.687,6-6,6Z",
    transform: "translate(5345 2784)",
    fill: "#ffffff"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDirectionArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/direction-arrow.e6815105ab6eebbcc5a921da383ee966.svg";